<template>
    <section class="article" v-if="this.$store.state.settings.site_id === 1">
        <ul class="list card-dop-sec__nav-line">
            <li @click="tab = 1" class="list__element card-dop-sec__nav-line-element " :class="tab === 1 ?'card-dop-sec__nav-line_active':''">
                {{ trans('p1') }}
            </li>
            <li @click="tab = 2" class="list__element card-dop-sec__nav-line-element" :class="tab === 2 ?'card-dop-sec__nav-line_active':''">
                {{ trans('p2') }}
            </li>
        </ul>


        <div class="card-dop-sec__tab card-dop-sec__tab_active" v-if="tab === 1">
            <p>{{ trans('p3') }}:</p>
            <ol class="article__list">
                <li class="article__payment-list-item">
                    <h3>{{ trans('p4') }}</h3>
                    <p class="article__payment-list-item-description">{{ trans('p5') }}
                    </p>
                </li>
                <li class="article__payment-list-item">
                    <h3>{{ trans('p6') }}</h3>
                    <p class="article__payment-list-item-description">{{ trans('p7') }}.</p>
                </li>
                <li class="article__payment-list-item" v-if="$store.state.settings.settings?.dolyami">
                    <h3>{{ trans('p8') }}</h3>
                    <p class="article__payment-list-item-description">{{ trans('p9') }} <a href="https://dolyame.ru/" class="article__link"> «{{ trans('p10') }}»</a>
                        - {{ trans('p11') }}
                       .</p>
                </li>
            </ol>
        </div>

        <div class="card-dop-sec__tab" v-if="tab === 2">
            <ol class="article__list">
                <li class="article__payment-list-item">
                    <h3>{{ trans('p12') }}</h3>
                    <p class="article__payment-list-item-description">
                        {{ trans('p13') }}.</p>
                </li>
            </ol>
        </div>
    </section>
    <section class="article" v-else-if="this.$store.state.settings.site_id === 2">
        <PaymentEn/>
    </section>
</template>

<script>

import PaymentEn from './en/payment.vue'
export default {
    components:{
        PaymentEn
    },

    name: "payment",
    data(){
        return{
            tab:1,
        }
    }
}
</script>

<style scoped>

</style>
